import config from '../../config/config';
import CF from '../common/common';

var url = config.url;

function template(doc) {
  var Ldiv = '';
  doc.links.forEach(function(linkObj, link_count) {
    if (linkObj.URL) {
      Ldiv += `<div><a class="pop-a" href="${linkObj.URL}" target="_blank">${linkObj.text}</a></div>`;
    }
  });

  $('#gjs').append(
    $(`<div class="pop-up-Doc hide">
        <div class="close-popup"><img src="${url}static/images/Console/Close-icon-img.svg"></div>
        <img src="${doc.image}" class="pop-img ${doc.image ? '' : 'hide'}">
        <div class="pop-title spacing">${doc.title}</div>
        <div class="pop-subTitle spacing">${doc.Sub_title}</div>
        <div class="pop-linkDiv spacing">${Ldiv}</div>
        <div class="pop-btnDiv spacing"></div>
    </div>`)
  );
}

let showFormattedPopup = function(e) {
  var $this, timeout_value;
  e.preventDefault();
  e.stopPropagation();
  $this = $(e.currentTarget);
  timeout_value = $this.data('popup_timer') || 0;
  setTimeout(function() {
    var docId, document;
    docId =
      $this.data('popup_doc_id') || $this.data('hover_popup_doc_id') || '';
    if (editor && editor.Config.documentation) {
      document = editor.Config.documentation.filter(function(x) {
        return x.uid === docId;
      });
      if (document.length) {
        // _this.fillSummaryDoc(index);
        template(document[0]);
        placeAndShowPopup($this);
      }
    }
  }, timeout_value);
};

let removePopup = function() {
  $('.pop-up-Doc').remove();
};

/*
    Function sets the top and left property for the popup depending on which item was hovered
*/
let placeAndShowPopup = function($el) {
  var height,
    left,
    popHeight,
    popWidth,
    spaceAvailableBelow,
    spaceAvailableRight,
    top,
    width,
    windowHeight,
    windowWidth;
  if (
    $el.data('popup_parent_param') &&
    $el.data('popup_parent_param') === true
  ) {
    $el = $el.parent();
  }
  left = $el.offset().left;
  top = $el.offset().top;
  width = $el.outerWidth();
  height = $el.outerHeight();
  popWidth = $('.pop-up-Doc').outerWidth();
  popHeight = $('.pop-up-Doc').outerHeight();
  windowWidth = window.innerWidth;
  windowHeight = window.innerHeight;

  //left or right
  spaceAvailableRight = windowWidth - left - width;
  if (popWidth > spaceAvailableRight) {
    //draw on left
    $('.pop-up-Doc').css('left', left - popWidth);
  } else {
    //draw on right
    //newLeft = left - popWidth
    $('.pop-up-Doc').css('left', left + width);
  }
  //newLeft = left + width
  spaceAvailableBelow = windowHeight - top - height;
  if (popHeight > spaceAvailableBelow) {
    //draw above
    $('.pop-up-Doc').css('top', top - popHeight);
  } else {
    //draw below
    //newTop=top+height-popHeight
    $('.pop-up-Doc').css('top', top - height / 2);
  }
  $('.pop-up-Doc').removeClass('hide');
  $('.pop-up-Doc .close-popup').on('click', removePopup);
};

let fetchPopupDetails = function() {
  var data = {
    operation: 'getControlInfoFromSheets'
  };

  function onSuccess(response) {
    response = JSON.parse(response);
    if (response.success && response.data) {
      response.data.forEach(function(item, index) {
        var links_arr, temp;
        if (item.data.Links_array_new_1591782873) {
          links_arr = JSON.parse(item.data.Links_array_new_1591782873);
        } else {
          links_arr = [];
        }
        temp = {
          uid: item.data.uid1_1591782873,
          title: item.data.Title_1591782873,
          Sub_title: item.data.sub_title_1591782873,
          links: links_arr,
          //'buttons':item.data.butto_JSON_1589802773483,
          image: item.data.banner_url_1591782873,
          rich_text: item.data.Rich_text_description_1591782873
        };
        editor.Config.documentation.push(temp);
      });
    }
  }
  function onError() {
    CF.ShowVSAlert('error', 'something went wrong!');
  }

  CF.fnAjaxRequest(
    url + 'Handler/studioConsole.ashx',
    'POST',
    data,
    onSuccess,
    onError
  );
};

let init = function() {
  fetchPopupDetails();
};

export default {
  init: init,
  showPopUp: showFormattedPopup,
  remove: removePopup
};
